
// @ts-nocheck # 忽略全文
//初始化参数

import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import pg2 from "@/assets/img/share/share_style@2x.png"
import COVERAPP from '@/utils/COVERAPP'
import { vueCanvasPoster } from 'vue-canvas-poster'
import InvitePoster from "../components/invite-poster.vue"
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import moment from 'moment'
import { throwStatement } from '@babel/types'


@Options({
    data() {

        return {
            codeImg: "",
            dataURL: "",
            showPoster: false,
            hidePoster: false,
            persnum: 0,
            city: "",//城市
            province: "",//省市
            name: "",//名字
            score: "",//积分
            imgurl: [//模型图片
                { style: require('../assets/img/share/share_modle_jian20@2x.png') },
                { style: require('../assets/img/share/share_modle_shanghai@2x.png') },
                { style: require('../assets/img/share/share_modle_tiangong@2x.png') },
                { style: require('../assets/img/share/share_modle_shandong@2x.png') },
                { style: require('../assets/img/share/share_modle_fuxinghao@2x.png') },
                { style: require('../assets/img/share/share_modle_tianfu@2x.png') },
                { style: require('../assets/img/share/share_modle_gangzhuao@2x.png') },
                { style: require('../assets/img/share/share_modle_mengxiangjia@2x.png') },
            ],
            polluser: [],
            startclienty: 0,//移动开始高度
            endclienty: 0, //移动结束高度
            headpic: "",//头像
            imgIndex: 0,//图片数组索引
            code: "",//抽奖码
            fromPage: "",
            interval: null,
            provincedata: {
                "北京市": "tjbj",
                "上海市": "tjsh",
                "重庆市": "tjcq",
                "天津市": "tjtj",
                "河北省": "tjhe",
                "山西省": "tjsx",
                "内蒙古自治区": "tjnm",
                "辽宁省": "tjln",
                "吉林省": "tjjl",
                "黑龙江省": "tjhl",
                "江苏省": "tjjs",
                "浙江省": "tjzj",
                "安徽省": "tjah",
                "福建省": "tjfj",
                "江西省": "tjjx",
                "山东省": "tjsd",
                "河南省": "tjha",
                "湖北省": "tjhb",
                "湖南省": "tjhn",
                "广东省": "tjgd",
                "广西壮族自治区": "tjgx",
                "海南省": "tjhi",
                "四川省": "tjsc",
                "贵州省": "tjgz",
                "云南省": "tjyn",
                "西藏自治区": "tjxz",
                "陕西省": "tjsn",
                "甘肃省": "tjgs",
                "青海省": "tjqh",
                "宁夏回族自治区": "tjnx",
                "新疆维吾尔自治区": "tjxj"
            },
            authname: ["空天", "海洋", "陆地", "梦想"],
            save: "长按头像保存",
            time: 0,
            modestatus: false,
        };
    },

    components: { InvitePoster, vueCanvasPoster },
    created() {
        // this.getGameinfo()
        // this.imgload()
        document.body.style.overflow = "hidden"
        
        
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData', 'GetUserParams'])
    },
    mounted() {
        this.init()
        this.drawhead()
        var _this = this
        if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
            let savepic = document.getElementById("save")
            savepic.style.display = "none"
        }
        const { templateConfig } = this.activityData
        let time = moment(this.activityData.templateConfig.gameEndTime).unix() - moment(this.activityData.serverTime).unix()
        this.time = time
        if(this.time<0){
            let foot2=document.getElementById('foot2')
            foot2.style.display="none"
        }
        // this.time = moment().unix() - moment(templateConfig.applyTime[1]).unix();
        this.$common.pageLoaded()
        // this.$common.track('load', '进入首页')
        //    this.COVERAPP.Method.OpenLogin(res=>{
        //     console.log(res)
        //    })
    },
    beforeRouteEnter(to, from, next) {
        console.log(from, 'beforeRouteEnter');
        console.log(to, 'beforeRoute');
        next(vm => {
            // vm相当于上面的this
            vm.fromPage = from.path;
            console.log("111");
            if (from.path == "/threed") {
                let color_egg = JSON.parse(sessionStorage.getItem("color_egg"))
                if (color_egg == true) {
                    vm.modestatus = true


                    vm.imgload()
                }
            }
        });
    },
    methods: {
        drawhead() {
            let offCanvas = document.createElement("canvas")
            let offctx = offCanvas.getContext("2d")
            offCanvas.width = 1600;
            offCanvas.height = 1600;
            let c = document.getElementById("head_canvas")
            let ctx = c.getContext("2d")
            let _this = this;
            //尺寸
            c.width = 1600;
            c.height = 1600;
            let d = new Image()
            d.setAttribute("crossOrigin", "anonymous")
            d.src = this.headpic
            let e = new Image()
            e.setAttribute("crossOrigin", "anonymous")
            e.src = pg2

            var base64
            let all = [{ "img": d, "position": [0, 0, 1600, 1600] }, { "img": e, "position": [0, 720, 960, 880] }]
            console.log(all);
            let num = 0
            for (var i = 0; i <= all.length - 1; i++) {
                let imaa = all[i]["img"]
                let pos = all[i]["position"]
                imaa.onload = function () {
                    num = num + 1
                    if (num == all.length) {
                        for (var t = 0; t <= all.length - 1; t++) {
                            let imaa1 = all[t]["img"]
                            let pos1 = all[t]["position"]
                            ctx.drawImage(imaa1, pos1[0], pos1[1], pos1[2], pos1[3])
                        }
                        offctx.drawImage(c, 0, 0)
                        base64 = offCanvas.toDataURL("image/png");
                        _this.codeImg = base64;
                    }
                }
                imaa.onerror = function () {
                    console.log("加载图片错误");

                }


            }
        },
        init() {
            this.code = localStorage.getItem('code')
            const { templateConfig } = this.activityData
            console.log(this.activityData);
            const persons = sessionStorage.getItem('GAME_USERINFO')
            this.polluser = templateConfig.prizeUser
            let day = this.DateDiff();
            let tjtotal = JSON.parse(JSON.stringify(this.provincedata))
            let CurrentHighestIntegral=localStorage.getItem("CurrentHighestIntegral")
            console.log("currentscore",CurrentHighestIntegral);
            if (persons != null) {
                
                var personscore = JSON.parse(persons)
                var cy = personscore.city || "成都市"
                this.city = cy.substring(0, 2)
                this.province = personscore.province || "四川省"
                if(personscore.score=="0"){
                    this.score=CurrentHighestIntegral
                }else{
                    this.score = personscore.score
                }
              
                console.log("目录", personscore.completed.length);
                if (personscore.completed.length == 7 || this.modestatus == true) {
                    this.imgIndex = 7
                } else {
                    this.imgIndex = Number(localStorage.getItem("modelId"))
                }
            }
            let prov = tjtotal[this.province]
            let tjBase = prov + "Base"
            let tjRatio = prov + "Ratio"
            let num = Math.round(templateConfig[tjBase] + day * templateConfig[tjRatio])
            this.persnum = num
            let usr = sessionStorage.getItem('COVER_USERINFO')
            var user
            if (usr != null) {
                user = JSON.parse(usr)
            }
            this.name = user.nickname
            this.headpic = user.headimgurl || user.avatar || require('../assets/img/default_man.png')
            let an;
            if (this.imgIndex == 0 || this.imgIndex == 2) {
                an = this.authname[0]
            } else if (this.imgIndex == 1 || this.imgIndex == 4 || this.imgIndex == 5) {
                an = this.authname[2]
            } else if (this.imgIndex == 3 || this.imgIndex == 6) {
                an = this.authname[1]
            } else if (this.imgIndex == 7) {
                an = this.authname[3]
            }
        

            let homeShareData = JSON.parse(JSON.stringify(this.shareData))
            homeShareData.title = "大国工程我来建｜我是" + this.province + "第" + this.persnum + "位" + an + "工程师"
            homeShareData.link = "https://activity.thepage.cn/dggcwlj/"
            homeShareData.desc = ""
            this.$common.onshare(homeShareData)

        },
        // 下载
        downloadCodeImg(Url) {
            var blob = new Blob([''], { type: 'application/octet-stream' });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = Url;
            a.download = Url.replace(/(.*\/)*([^.]+.*)/ig, "$2").split("?")[0];
            var e = document.createEvent('MouseEvents');
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
            URL.revokeObjectURL(url);

        },
        showExtension() {
            this.showPoster = true;
            let foot = document.getElementById('home')
            document.body.style.overflow = "hidden"
            foot.style.overflow = "hidden"
            return;
        },
        hidePosters() {
            this.showPoster = false;
            document.body.style.overflow = ""
            return;
        },
        end(e) {
            console.log(e)
            this.endclienty = e.changedTouches[0].clientY
            console.log("结束", this.endclienty);
            const foot = document.getElementById('foot')
            let footer = document.getElementById('footer')
            let delayfooter = document.getElementById('delayfooter')
            if (foot != null && footer != null && this.startclienty - this.endclienty > 120 && this.time > 0) {
                foot.style.display = "none"
                footer.style.display = ""
                document.body.style.overflow = "hidden"
            }
            if (foot != null && footer != null && this.startclienty - this.endclienty > 120 && this.time <= 0) {
                foot.style.display = "none"
                delayfooter.style.display = ""
                document.body.style.overflow = "hidden"
            }
            if (foot != null && footer != null && this.startclienty - this.endclienty < -120) {
                foot.style.display = ""
                footer.style.display = "none"
                delayfooter.style.display = "none"
                document.body.style.overflow = "hidden"
            }
        },
        changefoot() {
            console.log("时间" + this.time);
            const foot = document.getElementById('foot')
            let footer = document.getElementById('footer')
            let delayfooter = document.getElementById('delayfooter')
            if (foot != null && footer != null && this.time > 0) {
                foot.style.display = "none"
                footer.style.display = ""
                footer.style.overflow = ""
                delayfooter.style.display = "none"
                foot.style.overflow = "hidden"
                document.body.style.overflow = "hidden"
            }
            if (this.time <= 0) {
                foot.style.display = "none"
                delayfooter.style.display = ""
                delayfooter.style.overflow = ""
                foot.style.overflow = "hidden"
                footer.style.display = "none"
                document.body.style.overflow = "hidden"
            }
        },
        move(e) {
            this.startclienty = e.touches[0].clientY
            console.log("开始", this.startclienty);


        },
        changedelayfooter() {
            let foot = document.getElementById('foot')
            let footer = document.getElementById('delayfooter')
            if (foot != null && footer !== null) {
                foot.style.display = ""
                footer.style.display = "none"
                footer.style.overflow = "hidden"
                foot.style.overflow = ""
            }
        },
        changefooter() {
            let foot = document.getElementById('foot')
            let footer = document.getElementById('footer')
            if (foot != null && footer !== null) {
                foot.style.display = ""
                footer.style.display = "none"
                footer.style.overflow = "hidden"
                foot.style.overflow = ""
            }
        },
        gotoLink(pram) {
            this.$router.push(pram)
        },
        //计算两个日期差值（天）
        DateDiff() {    //sDate1和sDate2是2006-12-18格式
            let times = moment(this.activityData.serverTime).unix() - moment(this.activityData.templateConfig.tjTime[0]).unix()
            // if (moment(this.activityData.serverTime).unix() <= moment(this.activityData.templateConfig.tjTime[1]).unix()) {
            //     times = moment(this.activityData.serverTime).unix() - moment(this.activityData.templateConfig.tjTime[1]).unix()
            // }
            if (times < 0) {
                times = -times
            }
            return times
        },
        nowDate() {
            let now = new Date()
            var year = now.getFullYear(); //年份
            var month = now.getMonth() + 1; //月份（0-11）
            var date = now.getDate(); //天数（1到31）
            var hour = now.getHours(); //小时数（0到23）
            var minute = now.getMinutes(); //分钟数（0到59）
            var second = now.getSeconds(); //秒数（0到59） 
            return (
                year + "/" + month + "/" + date
            )
        },
        openLogin() {
            const _this = this;
            return new Promise((resolve) => {
                COVERAPP.Method.OpenLogin({
                    callback(user) {
                        if (user && (user.token || user.userid)) {
                            _this.SET_USERINFO(user);
                        }
                        resolve(user);
                    },
                });
            });
        },
        copy() {
            var copycode = document.getElementById("code").innerText;
            var input = document.createElement("input");   // js创建一个input输入框
            input.value = copycode;  // 将需要复制的文本赋值到创建的input输入框中，this.ruleForm.url这个是我要复制的内容
            document.body.appendChild(input);    // 将输入框暂时创建到实例里面
            input.select();   // 选中输入框中的内容
            document.execCommand("Copy");   // 执行复制操作
            document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
            this.$common.toast("复制成功")
        },
        //预加载序列图片
        loadImages(sources, callback) {
            console.log("执行了几次")
            let loadedImages = 0;
            let numImages = 0;
            let images = [];
            numImages = sources.length;
            for (var i = 0; i < sources.length; i++) {
                let img = new Image
                img.crossOrigin = "Anonymous"
                images[i] = img
                //当一张图片加载完成时执行
                images[i].onload = function () {
                    //当所有图片加载完成时，执行回调函数callback
                    if (++loadedImages >= numImages) {
                        callback(images);
                    }
                };
                images[i].onerror = function () {
                    this.$common.toast("动画错误")
                }
                images[i].src = sources[i];
                //把sources中的图片信息导入images数组
            }
        },
        //播放图片动画
        playImages(images) {
            const _this = this
            var imageNum = images.length;
            var imageNow = 0;
            let home = document.getElementById("home")
            let dream = document.getElementById("dream")
            if (dream != null) {
                dream.style.display = ""
                document.body.style.overflow = "hidden"
            }

            let canvas = document.getElementById("animation_canvas")
            if (home != null) {
                canvas.width = home.clientWidth;
                canvas.height = home.clientHeight;
            }
            var base64 = ""
            // images[imageNow].crossOrigin = "Anonymous"
            let ctx = canvas.getContext("2d")
            ctx.fillStyle = "rgba(0,0,0,0)";
            this.interval = setInterval(function () {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(images[imageNow], 0, 0, canvas.width, canvas.height);
                base64 = canvas.toDataURL("image/png");
                imageNow = imageNow + 1;
                if (imageNow >= imageNum) {
                    imageNow = 99;
                    let dream = document.getElementById("dream")
                    if (dream != null) {
                        dream.style.display = "none"
                        document.body.style.overflow = "";
                        clearInterval(_this.interval)
                    }
                }
            }, 40)

        },
        stopinterval() {
            // this.interval=0
            this.interval = clearInterval(this.interval)
        },
        //初始化
        imgload() {

            let sources = [];
            //构建图片序列数据
            for (var i = 0; i <= 99; i++) {
                sources[i] = require('../assets/img/pngseq/eggshell/' + (i + 1) + '.png');//根据项目修改
            }

            //ctx.globalAlpha=0.5
            //执行图片预加载，加载完成后执行main
            const _this = this
            this.loadImages(sources, function (images) {
                _this.playImages(images)

            });
        },
        async getGameinfo() {
            let usr = sessionStorage.getItem('COVER_USERINFO')
            var user
            if (usr != null) {
                user = JSON.parse(usr)
            }
            let usrdata = await this.$request('/temporary/dggcwlj/user', { "aid": "631ff5bf43b09f005038d8bd", "userinfo": user }, 'post').catch(res => {
                console.log('用户游戏信息测试数据错误', res)
            })
            sessionStorage.setItem("GAME_USERINFO", JSON.stringify(usrdata))
        }

    },

})
export default class Leaderboard extends Vue {
}

